interface AccessTokenIdentityClaims {
  sub?: string | number;
  user_id?: string | number;
  tenant_id?: string | number;
}

function decodeAccessTokenClaims(token: string): AccessTokenIdentityClaims | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
    return JSON.parse(atob(padded)) as AccessTokenIdentityClaims;
  } catch {
    return null;
  }
}

/** A stable permission identity that does not change during token rotation. */
export function permissionIdentity(
  tenantName: string | null,
  token: string | null,
): string | null {
  if (!tenantName || !token) return null;
  const claims = decodeAccessTokenClaims(token);
  const subject = claims?.sub ?? claims?.user_id;
  const tenant = claims?.tenant_id ?? tenantName;
  return `${tenant}:${subject ?? "authenticated"}`;
}
